var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWindowsAppIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Windows",
    transform: "translate(-724 -599)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Windows_logo_-_2021",
    d: "M0,0H6.637V6.634H0ZM7.363,0H14V6.634H7.363ZM0,7.363H6.637V14H0Zm7.363,0H14V14H7.363",
    transform: "translate(724 599)",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindowsAppIcon);
export default __webpack_public_path__ + "static/media/windows-app-icon.5fa3245141cd4efa68825f2f0ce4a00b.svg";
export { ForwardRef as ReactComponent };